<template>
    <div class="NoWavePicture">
        <p>nihao</p>
    </div>
</template>

<script>
import {ref, onBeforeMount, computed, watch,onMounted} from 'vue'
import { useRoute } from 'vue-router'
export default {
    name: 'NoWavePicture',
    setup(props, ctx){
        let route=useRoute();
        let data=route.query;
        //query:{data:JSON.stringify(options)}
        //query必须把JSON.stringify(options)包装在对象里赋给data再传，直接赋给query传不了
        onMounted(()=>{
            console.log(JSON.parse(data.data));
        })
        return {
            data
        }

    }
}
</script>

<style lang="scss">
    .NoWavePicture{
        background-color: #262c3a;
        height: calc(100vh - 70px);;
    }
</style>